import styled from "styled-components";

/**
 * The visible half of the drop affordance. Kelly's drag produced no highlight
 * at all; these styles are the fix, so they are deliberately not subtle.
 *
 * Accessibility notes that are requirements, not nice-to-haves:
 *  - the state is never signalled by COLOUR ALONE — the accepting and refusing
 *    states differ in their message text as well as their hue;
 *  - `prefers-reduced-motion` removes the transition entirely;
 *  - the overlay is `pointer-events: none` so it can never intercept the drop
 *    it is advertising.
 */

const PURPLE_700 = "#6F27D6";
const PURPLE_100 = "rgba(111, 39, 214, 0.08)";
const REFUSE = "#8B1F1F";

export const DropZoneWrap = styled.div`
  position: relative;
  /* The zone must not change the layout it wraps while idle. */
  display: contents;

  ${({ $active }) =>
    $active &&
    `
    display: block;
  `}
`;

export const DropOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border-radius: 12px;
  border: 2px dashed ${({ $accepting }) => ($accepting ? PURPLE_700 : REFUSE)};
  background: ${({ $accepting }) =>
    $accepting ? PURPLE_100 : "rgba(139, 31, 31, 0.06)"};
  transition: background 120ms ease, border-color 120ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const DropMessage = styled.p`
  margin: 8px 0 0;
  padding: 8px 14px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(18, 48, 81, 0.14);
  font: 600 13px "DM Sans", system-ui, sans-serif;
  color: ${({ $accepting }) => ($accepting ? PURPLE_700 : REFUSE)};
  text-align: center;
`;
